export class UploadStatus {
  constructor(readonly uploadName: string,
              readonly progress: number,
              readonly status: string) {
  }
}
